import { render, staticRenderFns } from "./FormInsights.vue?vue&type=template&id=1bceb346&scoped=true&"
import script from "./FormInsights.vue?vue&type=script&lang=js&"
export * from "./FormInsights.vue?vue&type=script&lang=js&"
import style0 from "./FormInsights.vue?vue&type=style&index=0&id=1bceb346&prod&lang=scss&"
import style1 from "./FormInsights.vue?vue&type=style&index=1&id=1bceb346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bceb346",
  null
  
)

export default component.exports